import React from 'react';

/**
 * Universal form field component for input, select, textarea
 * type: 'input' | 'select' | 'textarea'
 * label: string
 * ...rest: props for the element
 */
const FormField = ({
  type = 'input',
  label,
  options = [],
  ...rest
}) => {
  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      {type === 'input' && <input {...rest} />}
      {type === 'select' && (
        <select {...rest}>
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
      {type === 'textarea' && <textarea {...rest} />}
    </div>
  );
};

export default FormField;
